module.exports = __webpack_public_path__ + "assets/img/moni.05a35f52.png";